import React from 'react';
import { BodyRegular } from "@shared/ui/atoms/fonts/Body";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { selectCalendarDate } from "@shared/store/dashboard.duck";
import { HeadlineSmall } from "@shared/ui/atoms/fonts/Headline";
import { V2Colours } from "./WhereaboutsV2Styles";

export function DailyViewHeader(props: Props) {
  const calendarDate = useSelector(selectCalendarDate);
  return (
    <StickyHeader>
      {calendarDate && <DateHeaderRow>
        <HeadlineSmall>{calendarDate.format('dddd Do')}</HeadlineSmall>
      </DateHeaderRow>}
      <DayHeadersRow>
        <DayHeader><BodyRegular weight={600}>AM</BodyRegular></DayHeader>
        <DayHeader><BodyRegular weight={600}>PM</BodyRegular></DayHeader>
      </DayHeadersRow>
    </StickyHeader>
  )
}

interface Props {
}

const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
  background: white;
`;

const DateHeaderRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border-bottom: 5px solid ${V2Colours.indigo};
  padding: 10px 0 18px 0;
`;

const DayHeadersRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background: white;
`;

const DayHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 4px 7px 4px;
  p {
    line-height: normal;
  }
`;
